import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Supportph from "../../assets/pic/support.jpg";
import {Helmet} from "react-helmet";

const Demo = ()=>{
    return(
        <div className='demo-dec'>
            <Helmet>
                <title>دمو بل میت</title>
                <meta name="description" content="شما می توانید با دسترسی های زیر و ورود مهمان تا ظرفیت دو نفر بستر بل میت را چک نماید." />
            </Helmet>
            <Nav />
            <div className="demo-wrap">
                <h1>دمو بل میت</h1>
                <img src={Supportph} alt="دمو بل میت"/>
                <p>
                    برای دیدن محیط پلتفرم بل میت از لینک زیر استفاده کنید.
                </p>
                <div className='hero-btns'>
                    <a target="_blank" href="https://online.bellmeet.com/w/1/demo">
                        <button>Demo</button>
                    </a>
                </div>
                <p>
                    شما می توانید با دسترسی های زیر و ورود مهمان تا ظرفیت دو نفر بستر بل میت را چک نماید.
                </p>
                <ul>
                    <li>
                        دسترسی مدیر :
                        <br/>
                        Username: <span>bellmeet.admin</span>
                        <br/>
                        Password: <span>bellmeet.admin</span>
                    </li>
                </ul>
                <br/>
                <ul>
                    <li>
                        دسترسی استاد :
                        <br/>
                        Username: <span>bellmeet.host</span>
                        <br/>
                        Password: <span>bellmeet.host</span>
                    </li>
                </ul>
                <br/>
                <ul>
                    <li>
                        دسترسی ارائه دهنده :
                        <br/>
                        Username: <span>bellmeet.provider</span>
                        <br/>
                        Password: <span>bellmeet.provider</span>
                    </li>
                </ul>
                <br/>
                <ul>
                    <li>
                        دسترسی دانش پذیر :
                        <br/>
                        Username: <span>bellmeet.user</span>
                        <br/>
                        Password: <span>bellmeet.user</span>
                    </li>
                </ul>
                <br/>
                <p>همچنین جهت درخواست دمو بل میت به همراه کارشناسان ما و دریافت مشاوره اختصاصی می توانید با پشتیبانی در ارتباط باشید.</p>
                <h2>شماره تماس پشتیبانی:
                    26297306-021</h2>
                <p>در غیر اینصورت بدون پرداخت هزینه جهت آشنایی با BellMeet می توانید از قسمت ثبت نام، رایگان شروع کنید و یک سرویس کامل داشته باشید.</p>
                <div className='hero-btns'>
                    <a href='https://panel.bellmeet.com'>
                        <button>رایگان شروع کنید</button>
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Demo